import ticketRestrictionsModal from './rail-ticket-restrictions-modal.html';
import {SIZE_LARGE} from '../../common/modal/modal-service';

export default function RailTicketRestrictionsModal() {
    return {
        restrict: 'A',
        controller: RailTicketRestrictionsModalController,
        controllerAs: 'railTicketRestrictionsModalCtrl',
        link: function($scope, $elem, $attrs, railTicketRestrictionsModalCtrl) {
            $elem.on('click', () => {
                const code = $attrs.ktRailTicketRestrictionsModalCode && $scope.$eval($attrs.ktRailTicketRestrictionsModalCode) || null;
                const ticketType = $attrs.ktRailTicketRestrictionsModalTicketType && $scope.$eval($attrs.ktRailTicketRestrictionsModalTicketType) || null;
                const info = $attrs.ktRailTicketRestrictionsModalInfo && $scope.$eval($attrs.ktRailTicketRestrictionsModalInfo) || null;
                const tripId = $attrs.ktRailTicketRestrictionsModalTripId && $scope.$eval($attrs.ktRailTicketRestrictionsModalTripId) || null;

                railTicketRestrictionsModalCtrl.openTicketRestrictionsModal(code, ticketType, info, tripId);
            });
        },
    };
}

export function RailTicketRestrictionsModalController(
    $scope,
    modalService,
    railTicketRestrictionsModalService,
) {
    'ngInject';

    const vm = this;

    Object.assign(vm, {
        $onInit,
        openTicketRestrictionsModal,
    });

    function $onInit() {
    }

    function openTicketRestrictionsModal(code, ticketType, info, tripId) {
        const ticketTypeCode = code ? code : ticketType.Type;
        $scope.routeRestrictions = railTicketRestrictionsModalService.getRouteRestrictions(ticketType, info);
        railTicketRestrictionsModalService.getRestrictions(ticketTypeCode, tripId)
            .then((restrictions) => {
                $scope.restrictions = restrictions;
                modalService.openModal({
                    template: ticketRestrictionsModal,
                    scope: $scope,
                    size: SIZE_LARGE,
                });
            });
    }
}



// WEBPACK FOOTER //
// ./src/app/modules/ukrail/rail-ticket-restrictions-modal/rail-ticket-restrictions-modal-component.js